'use client';

import { useEffect, useState } from 'react';

import { ConsentStatus, useConsent } from '@domain/cookies/useConsent';
import { Button } from '../Clickables/Buttons/Button';
import { ExternalLink } from '../Clickables/ExternalLink/ExternalLink';
import { Modal } from '../Modal/Modal';
import { ModalBody } from '../Modal/ModalBody';
import { ModalFooter } from '../Modal/ModalFooter';
import { ModalHeader } from '../Modal/ModalHeader';
import { Text } from '../Text/Text';

const Links = () => (
  <>
    <ExternalLink href="/policies/terms-of-service/latest" target="_blank">
      Terms &amp; Conditions
    </ExternalLink>{' '}
    and{' '}
    <ExternalLink href="/policies/privacy/latest" target="_blank">
      Privacy Policy
    </ExternalLink>{' '}
    to continue using Fishbrain.
  </>
);

const UpdateCopy = () => (
  <Text className="m-0">
    We&apos;ve made some changes to make sure your information is stored securely. Please agree to
    our new <Links />
  </Text>
);

const NewUserCopy = () => (
  <Text className="m-0">
    Please agree to our <Links />
  </Text>
);

export const ConsentModal = () => {
  const [modalRenderingDelay, setModalRenderingDelay] = useState(true);
  const { consentStatus, acceptConsent } = useConsent();

  useEffect(() => {
    setTimeout(() => setModalRenderingDelay(false), 1);
  }, []);

  if (
    modalRenderingDelay ||
    consentStatus === ConsentStatus.NotLoggedIn ||
    consentStatus === ConsentStatus.Accepted
  ) {
    return <></>;
  }

  return (
    <Modal outerClassName="z-modal-consent" isOpen disableClose>
      <ModalHeader
        title={
          consentStatus === ConsentStatus.UpdateRequired
            ? 'Updated Terms and Conditions'
            : 'Fishbrain Terms and Conditions'
        }
      />
      <ModalBody>
        {consentStatus === ConsentStatus.UpdateRequired ? <UpdateCopy /> : <NewUserCopy />}
      </ModalBody>
      <ModalFooter>
        <div className="flex justify-end">
          <Button data-testid="ConsentAccept" onClick={acceptConsent} className="ml-auto">
            I Agree
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};
